export const PinStyles = () => {
  return (
    <style>{`
    .way-map path {
      stroke-width: 1px !important;
      stroke-opacity: 1 !important;
      position: relative;
      filter: drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.25));
    }

    .way-map path.selected {
      stroke-opacity: 1 !important;
      filter: drop-shadow(0px 0px 32px rgba(0, 0, 0, 0.6));
    }

    .way-map path.focused {
      filter: drop-shadow(0px 0px 32px rgba(0, 0, 0, 0.6));
    }

    .way-map path.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .shape-tooltip {
      background: unset;
      border: none;
      box-shadow: none;
    }
  
    .shape-tooltip span {
      font-size: 1.2em;
      color: #fff;
    }

    .shape-tooltip span.selected {
      color: #000 !important;
    }
    `}</style>
  )
}
